import { Component, ReactNode } from 'react';
import { APIRequestPost } from '../utils/APIRequests';
import { WeatherForecastInsertModemRequestData } from '../types/WeatherForecast';

interface Forecast {
    date: string;
    temperatureC: string;
    temperatureF: string;
    summary: string;
}

export class FetchData extends Component {
    static displayName = FetchData.name;

    override state: {
        loading: boolean;
        forecasts: Forecast[];
    }

    constructor(props: Record<string, unknown>) {
        super(props);
        this.state = {
            loading: true,
            forecasts: []
        };
    }

    override componentDidMount(): void {
        this.populateWeatherData();
    }

    static renderForecastsTable(forecasts: Forecast[]): ReactNode {
        return (
            <table className='table table-striped' aria-labelledby="tableLabel">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Temp. (C)</th>
                        <th>Temp. (F)</th>
                        <th>Summary</th>
                    </tr>
                </thead>
                <tbody>
                    {forecasts.map(forecast =>
                        <tr key={forecast.date}>
                            <td>{forecast.date}</td>
                            <td>{forecast.temperatureC}</td>
                            <td>{forecast.temperatureF}</td>
                            <td>{forecast.summary}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    override render(): ReactNode {
        const contents = this.state.loading ? (
            <p><em>Loading...</em></p>
        ) : (
            FetchData.renderForecastsTable(this.state.forecasts)
        );

        return (
            <div className='max-width text-page-padding'>
                <h1 id="tableLabel" >Weather forecast</h1>
                <p>This component demonstrates fetching data from the server.</p>
                {contents}
            </div>
        );
    }

    async populateWeatherData(): Promise<void> {
        const response = await fetch('weatherforecast');
        const data = await response.json();
        this.setState({ forecasts: data, loading: false });
        const article: WeatherForecastInsertModemRequestData = { imei: '356556773825345' };
        APIRequestPost('weatherforecast/insertModem', {
            data: article,
            logSuccess: true
        });
    }
}
